import { PhaseType } from '../../types';

export const PHASES: Record<string, PhaseType> = {
  START: 'START',
  END: 'END'
};
